import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';

import { ProgressSpinner } from 'primereact/progressspinner';


import moment from "moment";


// Load Actions
import * as AppActions from '../../Store/Actions/App';
import * as PartnerActions from '../../Store/Actions/Partner';

import HeaderView from '../../Components/Layout/Header';

// Load Componentes
import SideMenu from '../../Components/SideMenu';
import AlertView from '../../Components/AlertModal';
import StatusNotification from '../../Components/StatusNotification';

import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone
} from '../../Components/Utils';

import {
	Callto,
	Whatsapp,

} from '../../Components/Utils';

// export default function Reservation() {
const Users = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog,
	retrieveCompanyDashboard
} = props;

// Set Overlay obj
const op = React.useRef(null);

const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

// Table row selection
const [selectedItem, setSelectedItem] = React.useState(null);

// set this month dateFormat get current entire year as default
const currentDate = new Date();
const startYear = new Date(currentDate.getFullYear(), 0, 1); // 1 de Janeiro
const endYear = new Date(currentDate.getFullYear(), 11, 31); // 31 de Dezembro
var defaultRange = [startYear, endYear];

const [periodDate, setPeriodDate] = React.useState(defaultRange);

const [dashboardData, setDashboardData] = React.useState(null);

 
/* -------------------------------- */ 
/* Custom methods and options START */
/* -------------------------------- */
const retrieveItemsList = () => {
  const [start, end] = periodDate || [];

  const data = {
    startDate: start?.toISOString(),
    endDate: end?.toISOString()
  };

  retrieveCompanyDashboard(data, {
    setSuccess: (data) => setDashboardData(data),
    setError: (msg) => {
      setAlert(true);
      setAlertTitle("Erro ao carregar painel");
      setAlertBody(msg);
    }
  });
};


/* -------------------------------- */ 
/* Custom methods and options END */
/* -------------------------------- */
 
 
/* -------------------- */ 
/* Common methods START */
/* -------------------- */


// Run after mount component
React.useEffect(() => {

  // set scroll to top
  window.scrollTo(0, 1);
  
  // Load list
  retrieveItemsList();
      
  // Runs when UNMOUNT component
  return () => {
    
	// unmount...	
	
  };
  
}, []); // end useEffect 


// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 

/* -------------------- */ 
/* Common methods END */
/* -------------------- */
 
  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 

			<HeaderView isOnAdmin={true} />

			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start",marginTop:"6rem"}}>
				
				<div style={{flex:1,display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:isMobile ? "10px" : "40px",marginTop:"40px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:isMobile ? "" : "64px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
							
								<div style={{textAlign:"left",flex:2,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Painel</div>
							
							</div>
							
							
							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>

								
								{/* BLOCK AGENCIAS PANEL */}
								<div style={{margin:"20px",maxWidth:isMobile ? "100%" : "90%"}}>
									
										<div style={{marginBottom:"20px",textAlign:"left",fontSize:"26px",letterSpacing:"0.1em",lineHeight:"120%",fontWeight:"600",fontStyle:"normal",fontFamily:"Titillium Web",color:"#2E0249"}}> Status da empresa </div>
										
										<div style={{width:isMobile ? "100%" : "90%",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row",flexWrap:"wrap"}}>
										
										{dashboardData?.companyStatus === 1 && (
											<StatusNotification
											status="success"
											summary="Aprovado"
											message="O cadastro de sua empresa está aprovado e válido. Você está apto para receber direcionamentos."
											/>
										)}

										{dashboardData?.companyStatus == 2 && (
											<StatusNotification
											status="warn"
											summary="Em análise"
											message="O cadastro da sua empresa está em análise. Aguarde a verificação dos documentos para ativação."
											/>
										)}

										{dashboardData?.companyStatus == 3 && (
											<StatusNotification
											status="error"
											summary="Reprovado"
											message="O cadastro da sua empresa foi reprovado. Revise seus dados ou entre em contato com o suporte."
											/>
										)}

										{dashboardData?.companyStatus == 4 && (
											<StatusNotification
											status="error"
											summary="Pendência"
											message="O cadastro da sua empresa tem pendências e não pode receber direcionamentos. Verifique se tem um cartão de crédito cadastrado."
											/>
										)}			

										{dashboardData?.companyStatus === 9 && (
											<StatusNotification
											status="error"
											summary="Bloqueio"
											message="O cadastro da sua empresa foi bloqueado. Entre em contato com o suporte."
											/>
										)}																	

										{!dashboardData && (
											<>
											<div className="flex-row align-items-center justify-start gap-1">
												<ProgressSpinner style={{width:"50px",height:"50px"}} />
												<span style={{marginTop:"1rem",fontSize:"1.1rem",fontFamily:"Graphie"}}>Carregando status da empresa...Aguarde um momento.</span>
											</div>	
											</>										
										)}
										</div>
									
								</div>
									
									
								{/* BLOCK CUSTOMERS PANEL */}
								<div style={{margin:"20px",maxWidth:isMobile ? "100%" : "90%",marginTop:"2rem"}}>
								<div style={{marginBottom:"20px",textAlign:"left",fontSize:"26px",letterSpacing:"0.1em",lineHeight:"120%",fontWeight:"600",fontStyle:"normal",fontFamily:"Titillium Web",color:"#2E0249"}}>
									Notificações
								</div>

								<div style={{width:isMobile ? "100%" : "90%",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row",flexWrap:"wrap"}}>
									
									{/* Pendência de Cartão */}
									{dashboardData?.pendencias?.creditCard && (
									<StatusNotification
										status="error"
										summary="Pendência"
										message={<>Você não tem ao menos um <b>Cartão de crédito</b> cadastrado. Adicione ao menos um cartão de crédito para começar a receber direcionamentos.</>}
									/>
									)}

									{/* Pendência de Documentos */}
									{dashboardData?.pendencias?.comprovationDocuments && (
									<StatusNotification
										status="warn"
										summary="Atenção"
										message={<>Você não tem <b>Documentos comprobatórios</b> cadastrados. Adicione os documentos da sua empresa para evitar bloqueio do cadastro.</>}
									/>
									)}

									{/* Cadastro sem pendências */}
									{dashboardData && !dashboardData.pendencias?.creditCard && !dashboardData.pendencias?.comprovationDocuments && (
									<StatusNotification
										status="info"
										summary="Informação"
										message={<>Parabéns! O seu cadastro está completo e sem pendências.</>}
									/>
									)}

									{!dashboardData && (
										<>
										<div className="flex-row align-items-center justify-start gap-1">
											<ProgressSpinner style={{width:"50px",height:"50px"}} />
											<span style={{marginTop:"1rem",fontSize:"1.1rem",fontFamily:"Graphie"}}>Carregando pendências da empresa...Aguarde um momento.</span>
										</div>	
										</>										
									)}									
								</div>
								</div>



								{/* BLOCK REERVATIONS PANEL */}
								{/*<div style={{margin:"30px",maxWidth:"90%",marginTop:"2rem"}}>
									
										<div style={{marginBottom:"20px",textAlign:"left",fontSize:"26px",letterSpacing:"0.1em",lineHeight:"120%",fontWeight:"600",fontStyle:"normal",fontFamily:"Titillium Web",color:"#2E0249"}}> Direcionamentos </div>
										
										<div style={{display:"flex",alignItems:"center",justifyContent:"flex-start",gap:"20px",flexDirection:"row",flexWrap:"wrap"}}>
										
											<Card title={<div style={{backgroundColor:"orange",fontSize:"12px",padding:"5px",color:"white",borderRadius:"10px"}}>Aguardando Pagamento</div>} style={{width:"220px",maxHeight:"116px",backgroundColor:"whitesmoke"}}>
												<div style={{fontSize:"60px"}}>
													32
												</div>
											</Card>	
											

											<Card title={<div style={{backgroundColor:"lightgreen",fontSize:"12px",padding:"5px",color:"darkgreen",borderRadius:"10px"}}>Pagamento Confirmado</div>} style={{width:"220px",maxHeight:"116px",backgroundColor:"whitesmoke"}}>
												<div style={{fontSize:"60px"}}>
													1290
												</div>
											</Card>	
											

											<Card title={<div style={{backgroundColor:"red",fontSize:"12px",padding:"5px",color:"white",borderRadius:"10px"}}>Canceladas Agência</div>} style={{width:"220px",maxHeight:"116px",backgroundColor:"whitesmoke"}}>
												<div style={{fontSize:"60px"}}>
													21
												</div>
											</Card>													

											<Card title={<div style={{backgroundColor:"#7a0000",fontSize:"12px",padding:"5px",color:"white",borderRadius:"10px"}}>Canceladas Sistema</div>} style={{width:"220px",maxHeight:"116px",backgroundColor:"whitesmoke"}}>
												<div style={{fontSize:"60px"}}>
													9
												</div>
											</Card>	

											<Card title={<div style={{backgroundColor:"gray",fontSize:"12px",padding:"5px",color:"white",borderRadius:"10px"}}>Confirmação pendente</div>} style={{width:"220px",maxHeight:"116px",backgroundColor:"whitesmoke"}}>
												<div style={{fontSize:"60px"}}>
													3
												</div>
											</Card>	
											
											<Card title={<div style={{backgroundColor:"black",fontSize:"12px",padding:"5px",color:"white",borderRadius:"10px"}}>Sem disponibilidade</div>} style={{width:"220px",maxHeight:"116px",backgroundColor:"whitesmoke"}}>
												<div style={{fontSize:"60px"}}>
													0
												</div>
											</Card>												
										
										</div>
									
									</div>
								*/}
									
								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>
		

		
    </div>
	
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions,...PartnerActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Users);	


